import React, { Component, Fragment } from 'react';
import DataTable from 'react-data-table-component';
import { connect } from 'react-redux';

import Date from '../../../common/date';
import ExpanableLicence from './tabExpanableLicence';
import Loading from '../../../common/loading';
import CSVExport from '../../../common/csvExport';
import SelectorCopy from '../../../common/selectorCopy';
import { isNil } from '../../../utility';
import { controlRole } from '../../../common/actions/controlRole';
import ActionMenuLicence from '../../../players/components/actionMenuLicence';

class tabLicences extends Component {

    componentDidMount() {
        this.getLicenceList();
    }

    /**
     * La funzione prende in input l'id dell'utente selezionato (input preso in automatico dallo stato), 
     * e verifica i player associati ad esso
     * 
     */
    getLicenceList = () => {
        let params = {
            'elementsByPage': '1000',
            'filters[0][User]': this.props.userId,
        };

        setTimeout(() => {
            this.props.getLicenceList(params);
        }, 500);
    }

    render() {
        const { player, role } = this.props;
        const columns = [
            {
                name: 'Codice Attivazione',
                selector: row => <SelectorCopy item={row.key} infoNotify={this.props.infoNotify} />
            },
            {
                name: 'ID Utente',
                selector: row =>
                    row.user === null ? 'Utente non registrato'
                        :
                        <SelectorCopy item={row.user} infoNotify={this.props.infoNotify} />,
                minWidth: '280px'
            },
            {
                name: 'Device ID',
                selector: row =>
                    !row.playerId ? 'Player Non Associato'
                        :
                        <SelectorCopy item={row.playerId} infoNotify={this.props.infoNotify} />
            },
            {
                name: 'Platform',
                selector: row => (row.platform === 'sectv-tizen' || row.platform === 'tv-webos') ? "Samsung/LG" : "Android"
            },
            {
                name: 'Creato il',
                selector: row => <Date format="L" date={row.createdAt} />
            },
            // menu azioni solo se l'utente ha almeno un'azione disponibile sulle licenze
            ...(controlRole(role.player, "api/Player/FreeLicence", "PUT") ? [{
                name: '',
                selector: row => <ActionMenuLicence licence={row} data={player.listLicences} />,
                right: true,
                button: true,
                allowOverflow: true,
                width: '60px'
            }] : [])
        ];

        const customStyles = {
            rows: {
                style: {
                    minHeight: '50px',
                }
            },
            headCells: {
                style: {
                    paddingLeft: '8px',
                    fontWeight: 600,
                },
            },
            headRow: {
                style: {
                    minHeight: '35px',
                },
            },
            cells: {
                style: {
                    paddingLeft: '8px',
                },
            },
        };

        return (
            <Fragment>
                {this.props.player.isLoading && <Loading />}
                {
                    !this.props.player.isLoading &&
                    <Fragment>
                        <div className="row title">
                            <div className="col-6">
                                <h2>Numero Licenze: <span className="badge text-bg-secondary">{player.totalLicences}</span></h2>
                            </div>

                            {
                                !isNil(player.listLicences) &&
                                <div className="col-6 text-end">
                                    <CSVExport
                                        data={player.listLicences}
                                        filename="list-licences.csv"
                                        label="Scarica la lista delle licenze selezionate"
                                    />
                                </div>
                            }
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <hr />
                                <DataTable
                                    columns={columns}
                                    data={player.listLicences}
                                    customStyles={customStyles}
                                    noHeader
                                    striped
                                    highlightOnHover
                                    pointerOnHover
                                    clearSelectedRows
                                    expandableRows={this.props.player.isLoading ? false : true}
                                    expandOnRowClicked
                                    expandableRowsComponent={ExpanableLicence}
                                    expandableRowsComponentProps={{ infoNotify: this.props.infoNotify }}
                                />
                            </div>
                        </div>
                    </Fragment>
                }
            </Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state,
        player: state.player
    };
};

export default connect(mapStateToProps)(tabLicences);